import React from 'react';
import styled from 'styled-components';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import ChevronIcon from 'src/assets/chevron-icon';

import useColors from 'hooks/use-colors';

export type AccordionBannerProps = {
  graphic?: React.ReactNode;
  mainContent: React.ReactNode;
  toggleContent?: React.ReactNode;
  borderRadius?: string;
  marginBottom?: string;
};

export const AccordionBanner: React.FC<AccordionBannerProps> = ({
  graphic,
  mainContent,
  toggleContent,
  borderRadius,
  marginBottom,
}) => {
  const colors = useColors();

  return (
    <StyledAccordion square $borderRadius={borderRadius} $marginBottom={marginBottom}>
      <StyledSummary expandIcon={toggleContent && <ChevronIcon height={10} width={10} fill={colors.green90} />}>
        <Graphic>{graphic}</Graphic>
        <MainContent>{mainContent}</MainContent>
      </StyledSummary>
      {toggleContent && <AccordionDetails>{toggleContent}</AccordionDetails>}
    </StyledAccordion>
  );
};

const StyledAccordion = styled(Accordion)<{ $borderRadius?: string; $marginBottom?: string }>`
  &.MuiPaper-root {
    width: 100%;
    background-color: ${({ theme }) => theme.colors.green20};
    box-shadow: none;
    border: none;
    min-height: 68px;
    font-size: 13px;
    line-height: 18px;
    border-radius: ${({ $borderRadius }) => $borderRadius ?? '4px'};
    ${({ $marginBottom }) => $marginBottom && `margin-bottom: ${$marginBottom};`}
    z-index: 1;
    overflow: hidden;
  }

  &.MuiAccordion-root.Mui-expanded {
    margin-bottom: ${({ $marginBottom }) => $marginBottom ?? ''};
  }

  a {
    color: ${({ theme }) => theme.colors.green90};
    text-decoration: underline;
  }
`;

const StyledSummary = styled(AccordionSummary)`
  &.MuiAccordionSummary-root {
    margin: 0;
    padding: ${({ theme }) => `${theme.spaces[2]} ${theme.spaces[4]} ${theme.spaces[2]} ${theme.spaces[1]}`};
    height: 68px;
    gap: ${({ theme }) => theme.spaces[2]};
  }
`;

const MainContent = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${({ theme }) => theme.spaces[3]};
`;

const Graphic = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
`;
